import React from 'react'
import AdmitAiMobWrapper from './Mobile/components/AdmitAiMobWrapper'

const AdmitAiWrapper = () => {
  return <AdmitAiMobWrapper />
}

export default AdmitAiWrapper
